// config.js

const bizIcon = "https://images.marketleader.com/Logos/80/920080_normal.jpg";
const imageOne = "https://images.marketleader.com/mastheads/catalog/ML-masthead-Light_1210676974_f.jpg";
const imageTwo = "https://images.marketleader.com/HouseImages/Baystate/593/73306593.jpg?PhotoAccessKey=cfaf15d78ea50c0c99cdb3d0d0b5336f";
const imageThree = "https://images.marketleader.com/HouseImages/Baystate/273/f_73301273.jpg?PhotoAccessKey=cfaf15d78ea50c0c99cdb3d0d0b5336f";
const imageFour = "https://images.marketleader.com/HouseImages/Baystate/868/73301868.jpg?PhotoAccessKey=cfaf15d78ea50c0c99cdb3d0d0b5336f";
const imageFive = "https://images.marketleader.com/MarketingImages/82/2403682_normal.jpg";

export const siteConfig = {
  title: "Lisa Moccia",
  metaDescription: "Lisa Moccia | Keller Williams",
  theme: {
    primaryColor: "blue-600",
    secondaryColor: "gray-900",
    accentColor: "text-yellow-500"
  },
  logo: {
    src: bizIcon,
    alt: "Lisa Moccia | Keller Williams",
  },
  navigation: [
    { name: "Services", sectionId: "services" },
    { name: "About", sectionId: "about" },
    { name: "Location", sectionId: "location" },
  ],
  businessDetails: {
    name: "Lisa Moccia | Keller Williams",
    headline: "Your Trusted Real Estate Expert in Massachusetts",
    address: "66 Dwight Rd, Longmeadow, MA 01106",
    description: "With years of experience in residential and commercial real estate, Lisa Moccia provides personalized, professional service to guide you through every step of the home buying or selling process. Specializing in luxury homes, first-time buyers, and investment properties.",
  },
  images: {
    business: {
      src: imageOne,
      alt: "Your Trusted Real Estate Expert in Massachusetts",
      width: 2432,
      height: 1442
    }
  },
  features: [
    {
      name: 'Local Market Expertise',
      description: 'With a deep understanding of the local real estate market, Lisa provides insights into market trends, property values, and investment opportunities, ensuring you make informed decisions.',
    },
    {
      name: 'Personalized Home Search Tools',
      description: 'Gain access to industry-leading tools that allow you to customize your home search, track market changes, and understand your home’s value.',
    },
    {
      name: 'Skilled Negotiation',
      description: 'As a proven negotiator, Lisa advocates for your best interests at every stage of the buying or selling process, ensuring optimal outcomes for her clients.',
    },
  ],
  services: {
    sectionTitle: "Communities Served",
    description: "Lisa Moccia is proud to serve a diverse range of communities in the Massachusetts area, providing personalized real estate services tailored to each unique neighborhood. From first-time homebuyers to seasoned investors, Lisa brings local market knowledge, community insights, and a commitment to finding the perfect home for each client.",
    callouts: [
      {
        name: 'Agawam',
        description: 'A family-friendly town with vibrant parks and a welcoming community.',
        details: 'With excellent schools, spacious parks, and a range of local amenities, Agawam is a fantastic place for families looking to settle down. Lisa’s knowledge of the area ensures you’ll find a home that fits your lifestyle.',
        imageSrc: imageTwo,
        imageAlt: 'Agawam community and parks',
      },
      {
        name: 'Chicopee',
        description: 'An up-and-coming area with a mix of historic charm and modern living.',
        details: 'Chicopee offers a unique blend of historic architecture and modern amenities, making it ideal for those looking for character and convenience. Lisa’s familiarity with Chicopee helps clients find homes with the best value and potential.',
        imageSrc: imageThree,
        imageAlt: 'Chicopee historic downtown',
      },
      {
        name: 'Indian Orchard',
        description: 'A community known for its rich history and affordable housing options.',
        details: 'Indian Orchard is perfect for first-time homebuyers and investors alike, with affordable housing options and a strong sense of community. Lisa can guide you through the best investment opportunities here.',
        imageSrc: imageFour,
        imageAlt: 'Indian Orchard neighborhood',
      }
    ],
    otherServices: [
      "Longmeadow",
      "Springfield",
      "West Springfield"
    ]
  },
  about: {
    sectionTitle: "About Lisa Moccia",
    description: "In today's competitive real estate market, you need a dedicated local advisor to help you navigate the home buying and selling process. Lisa Moccia brings extensive local market knowledge and a passion for helping clients find their perfect home. As a valued client, you'll benefit from Lisa's expertise in negotiations, personalized search tools, and her commitment to supporting you every step of the way.",
    bulletPoints: [
      "In-depth local market knowledge to help you make informed decisions.",
      "Access to industry-leading real estate tools for home valuation and customized searches.",
      "Skilled negotiator dedicated to securing the best outcomes for her clients.",
      "A trusted partner from initial consultation through closing and beyond.",
    ],
    image: {
      src: imageFive,
      alt: "Lisa Moccia, real estate agent",
      width: 1200,
      height: 800
    }
  },
  location: {
    sectionTitle: "Our Location",
    destinationAddress: "66 Dwight Rd, Longmeadow, MA 01106, USA",
    googleMapsEmbedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2944.598346635657!2d-72.56211928454257!3d42.05034537920851!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89e6e3d5fdc816ad%3A0x3c43f1d4df5b4b78!2s66%20Dwight%20Rd%2C%20Longmeadow%2C%20MA%2001106%2C%20USA!5e0!3m2!1sen!2sus!4v1710407450828!5m2!1sen!2sus",
    subCategories: [
      { name: 'Apple Maps', url: 'https://maps.apple.com/?address=66%20Dwight%20Rd,%20Longmeadow,%20MA%2001106&ll=42.0503,-72.5621&q=66%20Dwight%20Rd' },
      { name: 'Bing Maps', url: 'https://www.bing.com/maps?q=66+Dwight+Rd,+Longmeadow,+MA+01106&FORM=HDRSC6' },
      { name: 'Google Earth', url: 'https://earth.google.com/web/search/66+Dwight+Rd,+Longmeadow,+MA+01106,+USA/@42.0503453,-72.5621192,15a,814.57589625d,35y,0h,0t,0r' },
      { name: 'Google Maps', url: 'https://goo.gl/maps/4Y2YfHGWxgrC8tTE7' }
    ]
  },
  contact: {
    sectionTitle: "Ready to Find Your Dream Home?",
    description: "Contact Lisa Moccia to discuss your real estate needs or to schedule a consultation. Whether you're buying, selling, or investing, Lisa is here to provide expert guidance every step of the way.",
    manager: {
      name: "Lisa Moccia",
      title: "Real Estate Agent",
      email: "lisamoccia@kw.com",
    },
    socialLinks: {
      facebook: "https://www.lisa-moccia.com/",     
      instagram: "https://www.lisa-moccia.com/",
      twitter: "https://www.lisa-moccia.com/",
      linkedin: "https://www.lisa-moccia.com/",
      youtube: "https://www.lisa-moccia.com/"
    },
    contactNumbers: [
      "Mobile: (413) 750-8346",
      "Office: (413) 750-8346"
    ],
    logo: bizIcon,
    emailRecipient: "LisaMoccia@kw.com"
  },
  footer: {
    bizSolutionsLogo: "https://mybizsolutions.us/static/media/icon-app-logo.83ff8bf39a11df9fb7ac.jpg"
  }
};
